import { tracking as barkTrackingLogEvent } from '@bark/bark-core';

const clickIdParams = ['gclid', 'msclid', 'fbclid', 'ttclid', 'oppref', 'campaign'];

const SLF_SELLER_PROFILE_PATH = '/slf/p/';

const patterns = [
	'^utm_', // ^ means starts with
	'^trk_',
	'^fbclid',
	'^_fbp$', // $ means ends with
	'^_fbc$',
	'^campaign$',
	'^ptcode$',
	'^aff_trk_',
];


export const getMarketingCookies = () => {
	const marketingValues = {
		...getMarketingParamsFromUrl(),
	};

	return JSON.stringify(marketingValues);
};



const getMarketingParamsFromUrl = () => {
	const tracking = {};
	const urlParams = new URLSearchParams(window.location.search);

	clickIdParams.forEach((param) => {
		if (urlParams.has(param)) {
			tracking[param] = urlParams.get(param);
		}
	});

	urlParams.forEach((value, key) => {
		if (key.startsWith('utm_') || key.startsWith('trk_')) {
			tracking[key] = value;
		}
	});

	return tracking;
};




const getMarketingParamsFromCookies = () => {
	return {
		...filterMarketingParams(getAllCookies()),
	};
};

const getAllCookies = () => {
	const cookies = {};
	const cookieParts = document.cookie.split(';');
	let i;

	let name_value = [];
	for (i = 0; i < cookieParts.length; i++) {
		try {
			name_value = cookieParts[i].split('=');
			// Strip the space that may be around the semicolon
			name_value[0] = name_value[0].replace(/^ /, '');
			cookies[decodeURIComponent(name_value[0])] = decodeURIComponent(name_value[1]);
		} catch (e) {
			// Ignore
		}
	}
	return cookies;
};

function getInteractionSource() {
	if (QS.getValue('fromRoute') === 'martech') return 'seller_profile';
	if (QS.getValue('seller_list_id') || getTrkFromUrl()?.search_list_id) return 'seller_profile';

	const cookies = getAllCookies();
	const barkLanding = cookies['trk_bark_landing_page'];
	const initialRef = cookies['trk_initial_referrer'];
	const hostname = window?.Bark?.ENV?.web_hostname || window?.location?.hostname || '';

	if (window.__barkTracking) {
		try {
			const newBarkLanding = window.__barkTracking.getParam('trk_bark_landing_page') || null;
			const newInitialRef = window.__barkTracking.getParam('trk_initial_referrer') || null;
			window.DD_RUM?.addAction('bark_attribution_read_compare', {
				read_point: 'getInteractionSource',
				old_value: { trk_bark_landing_page: barkLanding, trk_initial_referrer: initialRef },
				new_value: { trk_bark_landing_page: newBarkLanding, trk_initial_referrer: newInitialRef },
				match: barkLanding === newBarkLanding && initialRef === newInitialRef,
				url: window.location.href,
			});
		} catch (e) { /* never break interaction source detection */ }
	}

	const isSameSite = (ref) =>
		ref && typeof ref === 'string' && hostname && ref.toLowerCase().includes(hostname.toLowerCase());

	if (
		barkLanding?.includes(SLF_SELLER_PROFILE_PATH) &&
		!isSameSite(initialRef) &&
		!isSameSite(document.referrer)
	) {
		return 'seller_profile_landing';
	}
	return 'seller_profile';
}

const filterTracking = (source) => {
	const tracking = {};

	let i;
	let re;

	for (const item in source) {
		for (i = 0; i < patterns.length; i++) {
			re = new RegExp(patterns[i]);

			if (item.match(re)) {
				tracking[item] = source[item];
				break;
			}
		}
	}

	return tracking;
};

const filterMarketingParams = (source) => {
	const marketing = {};
	let i;
	let re;

	for (const item in source) {
		for (i = 0; i < patterns.length; i++) {
			re = new RegExp(patterns[i]);

			if (item.match(re)) {
				marketing[item] = source[item];
				break;
			}
		}
	}

	return marketing;
};

export const buildPolarisRedirectUrl = (url) => {
	const params = new URLSearchParams();
	params.set('su', 'polaris');

	if (url) {
		params.set('redirect_uri', `${encodeURIComponent(url)}&token=`);
	}

	return `${window.location.origin}/polaris/redirect/?${params.toString()}`;
};

export function getSessionId() {
	const sessionId = QS.getValue('sessionId') || getAllCookies()['bes-token'] || '';

	if (window.__barkTracking) {
		try {
			const newBesToken = window.__barkTracking.getBesToken() || '';
			window.DD_RUM?.addAction('bark_attribution_read_compare', {
				read_point: 'getSessionId',
				old_value: sessionId,
				new_value: newBesToken,
				match: sessionId === newBesToken,
				url: window.location.href,
			});
		} catch (e) { /* never break session id reads */ }
	}

	return sessionId;
}

function getLocationInteraction() {
	try {
		const locationFromLocaleStorage = localStorage.getItem('slf-location');
		const parsedLocationFromLocaleStorage = JSON.parse(locationFromLocaleStorage);
		var locationInteraction = {
			name: parsedLocationFromLocaleStorage.location.name,
			id: parsedLocationFromLocaleStorage.location.id,
			type: parsedLocationFromLocaleStorage.location.type,
		};
		return locationInteraction;
	} catch (error) {
		console.error('Error parsing location from localStorage:', error);
		// Fallback to query string if localStorage fails
		return {
			name: QS.getValue('location') || '',
			id: QS.getValue('locationId') || '',
			type: QS.getValue('locationType') || '',
		};
	}
}

function getFiltersFromLocalStorage() {
	try {
		const filtersFromLocaleStorage = localStorage.getItem('slf-filters');
		const parsedFiltersFromLocaleStorage = JSON.parse(filtersFromLocaleStorage ?? {});
		return parsedFiltersFromLocaleStorage;
	} catch (error) {
		return {};
	}
}

export function getBackLinkWithQueryParams(backLink, additionalQueryParams) {
	let searchParams = new URLSearchParams(window.location.search).toString();
	if (additionalQueryParams) {
		const queryParamsString = new URLSearchParams(additionalQueryParams).toString();
		searchParams += `&${queryParamsString}`;
	}
	return `${backLink}${searchParams ? `?${searchParams}` : ''}`;
}

/**
 * Parses the trk URL param. Martech passes full tracking as trk=JSON (search_session_id,
 * search_list_id, marketing_tracking, etc.) - not as individual query params.
 */
function getTrkFromUrl() {
	try {
		const trkParam = new URLSearchParams(window.location.search).get('trk');
		if (!trkParam) return null;
		return JSON.parse(trkParam);
	} catch {
		return null;
	}
}

export function buildInteractionSolutionUrl(data, path) {
	const consumerFrontendUrl = '/consumer';

	const trkFromUrl = getTrkFromUrl();

	// URL params take priority - preserve existing session, don't start new
	const searchID =
		QS.getValue('searchID') ||
		trkFromUrl?.search_id ||
		localStorage.getItem('search_id') ||
		'';
	const searchSessionId =
		QS.getValue('search_session_id') || trkFromUrl?.search_session_id || '';
	const sellerListId =
		QS.getValue('seller_list_id') || trkFromUrl?.search_list_id || '';
	const marketingTracking =
		trkFromUrl?.marketing_tracking || getMarketingCookies();

	if (window.__barkTracking) {
		try {
			var newData = JSON.stringify(window.__barkTracking.getParams());
			window.DD_RUM?.addAction('bark_attribution_read_compare', {
				read_point: 'buildInteractionSolutionUrl',
				old_value: marketingTracking,
				new_value: newData,
				match: marketingTracking === newData,
				url: window.location.href,
			});
		} catch (e) { /* never break the interaction flow */ }
	}

	const category = {
		category_name: QS.getValue('categoryName'),
		category_slug: QS.getValue('category_slug'),
		category_id: QS.getValue('categoryId'),
	};

	const locationInteraction = getLocationInteraction();
	const interactionSource = getInteractionSource();

	const queryParamsObj = {
		project: JSON.stringify({
			seller_profile_id: data.spid.toString(),
			country_id: window.Bark.ENV.ccid.toString(),
			category_slug: category.category_slug,
			category_id: category?.category_id?.toString(),
			location_id: locationInteraction?.id?.toString(),
			location_name: locationInteraction?.name?.toString() ?? undefined,
			location_type: locationInteraction?.type?.toString() ?? undefined,
			seller_user_id: data.userId.toString(),
			alid_phy: QS.getValue('trk_alid_phy'),
			alid_int: QS.getValue('trk_alid_int'),
		}),
		trk: JSON.stringify({
			search_id: searchID,
			marketing_tracking: marketingTracking,
			session_id:
				QS.getValue('sessionId') ||
				trkFromUrl?.session_id ||
				(() => {
					const oldBesToken = getAllCookies()['bes-token'] || '';
					if (window.__barkTracking) {
						try {
							const newBesToken = window.__barkTracking.getBesToken() || '';
							window.DD_RUM?.addAction('bark_attribution_read_compare', {
								read_point: 'buildInteractionSolutionUrl_besToken',
								old_value: oldBesToken,
								new_value: newBesToken,
								match: oldBesToken === newBesToken,
								url: window.location.href,
							});
						} catch (e) { /* never break the interaction flow */ }
					}
					return oldBesToken;
				})() ||
				'',
			search_session_id: searchSessionId,
			seller_list_id: sellerListId,
			search_list_id: sellerListId,
			source: interactionSource,
		}),
		filters: JSON.stringify(getFiltersFromLocalStorage()),
		return_url: getBackLinkWithQueryParams(window.location.pathname),
	};

	const params = new URLSearchParams(queryParamsObj);
	params.set(
		'web_hostname',
		window.location.hostname.endsWith('/')
			? window.location.hostname.slice(0, -1)
			: window.location.hostname,
	);

	const urlParams = Object.fromEntries(
		new URLSearchParams(window.location.search).entries(),
	);

	barkTrackingLogEvent('Seller_list_first', 'Build Interaction Solution URL', {
		...queryParamsObj,
		...urlParams,
		source: interactionSource,
	});
	window.localStorage.setItem(
		'inbox_back_link_data',
		JSON.stringify({ link: window.location.href, source: 'profile' }),
	);

	return `${consumerFrontendUrl}/${path}?${params.toString()}`;
}
